export function AvatarFallbackUserIcon({ size = 18 }: { size?: number }) {
	return (
		<svg
			aria-hidden
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="-0.305 -0.305 19 19"
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5325}
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M13.026 6.12825C13.026 8.24426 11.3107 9.95962 9.19466 9.95962C7.07865 9.95962 5.36328 8.24426 5.36328 6.12825C5.36328 4.01224 7.07865 2.29688 9.19466 2.29688C11.3107 2.29688 13.026 4.01224 13.026 6.12825Z" />
			<path d="M15.3249 16.0911C15.3249 14.4653 14.679 12.9061 13.5294 11.7564C12.3797 10.6068 10.8205 9.96094 9.19465 9.96094C7.56882 9.96094 6.00958 10.6068 4.85995 11.7564C3.71031 12.9061 3.06445 14.4653 3.06445 16.0911" />
		</svg>
	);
}
